import { Link } from 'react-router-dom'

const font = "'Geist', 'Geist Variable', ui-sans-serif, system-ui, sans-serif"

const linkStyle = {
  fontSize: '14px',
  color: '#9A8A7A',
  textDecoration: 'none',
  lineHeight: '18px',
  fontFamily: font,
  transition: 'opacity 150ms ease',
}

const colHeaderStyle = {
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.1em',
  color: '#5A4A3A',
  textTransform: 'uppercase' as const,
  lineHeight: '14px',
  fontFamily: font,
}

const PRODUCT_LINKS = [
  { label: 'Features', to: '/features' },
  { label: 'How it works', to: '/how-it-works' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Changelog', to: '/changelog' },
]

type LegalLink = { label: string; to: string } | { label: string; href: string }

const LEGAL_LINKS: LegalLink[] = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Service', href: '#' },
  { label: 'Cookie Policy', href: '#' },
  { label: 'Security', href: '#' },
]

export default function MarketingFooter() {
  return (
    <footer
      style={{
        background: '#1A1714',
        fontFamily: font,
        padding: '64px 120px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: 48,
      }}
    >
      {/* Main row */}
      <div style={{ display: 'flex', gap: 80 }}>

        {/* Brand col */}
        <div style={{ flex: '1.5 1 0', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/CornerLogo.svg" alt="Corner" style={{ width: 24, height: 24 }} />
            <span style={{ fontSize: '15px', fontWeight: 600, letterSpacing: '-0.01em', color: '#F2EDE6', fontFamily: font }}>
              Corner
            </span>
          </div>
          <p style={{ fontSize: '14px', color: '#7A6B5A', lineHeight: '165%', margin: 0, maxWidth: 260 }}>
            One workspace for all your documents. Convert, sign, analyze, and share — without switching apps.
          </p>
        </div>

        {/* Product col */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <span style={colHeaderStyle}>Product</span>
          {PRODUCT_LINKS.map(({ label, to }) => (
            <Link key={to} to={to} style={linkStyle}
              onMouseEnter={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.color = '#F2EDE6' }}
              onMouseLeave={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.color = '#9A8A7A' }}
            >
              {label}
            </Link>
          ))}
        </div>

        {/* Legal col */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <span style={colHeaderStyle}>Legal</span>
          {LEGAL_LINKS.map((link) => (
            'to' in link ? (
              <Link
                key={link.label}
                to={link.to}
                style={linkStyle}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#F2EDE6' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#9A8A7A' }}
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.label}
                href={link.href}
                style={linkStyle}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#F2EDE6' }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#9A8A7A' }}
              >
                {link.label}
              </a>
            )
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 24 }}>
        <span style={{ fontSize: '13px', color: '#5A4A3A', fontFamily: font }}>
          © 2025 Corner. All rights reserved.
        </span>
        <span style={{ fontSize: '13px', color: '#5A4A3A', fontFamily: font }}>
          Built with ♥ by students
        </span>
      </div>
    </footer>
  )
}
